exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._1zZz1N5ZvuI8BZagfW2qSj {\n  display: block; }\n", ""]);

// exports
exports.locals = {
	"button": "_1zZz1N5ZvuI8BZagfW2qSj"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/js/standard/StepForwardButton/styles.scss
// module id = 55
// module chunks = 0